// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// KPI-Zahlen zählen beim ersten Erscheinen hoch (Skill §3): rAF, ~500ms,
// ease-out; bei reduzierter Bewegung sofort der Endwert.
import { useEffect, useRef, useState } from "react"

// Was in dieser Sitzung schon einmal hochgezählt hat, springt beim nächsten
// Tab-Wechsel direkt auf den Wert. Sonst starten die Kennzahlen bei jedem
// Seitenaufruf wieder bei 0 — das liest sich als „lädt", nicht als Freude
// (Skill §9, Häufigkeits-Regel).
const gezaehlt = new Set<string>()

export function useCountUp(target: number, schluessel: string, durationMs = 500): number {
  const [value, setValue] = useState(() => (gezaehlt.has(schluessel) ? target : 0))
  const started = useRef(false)

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setValue(target)
      return
    }
    // Nur der erste Wert wird animiert; spätere Updates (Sync) springen direkt.
    if (started.current || gezaehlt.has(schluessel)) { setValue(target); return }
    if (target === 0) { setValue(0); return }
    started.current = true
    gezaehlt.add(schluessel)
    const t0 = performance.now()
    let raf = 0
    const tick = (now: number) => {
      const p = Math.min(1, (now - t0) / durationMs)
      const eased = 1 - Math.pow(1 - p, 3)
      setValue(Math.round(target * eased))
      if (p < 1) raf = requestAnimationFrame(tick)
    }
    raf = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(raf)
  }, [target, schluessel, durationMs])

  return value
}
